import { Link } from "react-router-dom";
import { Stethoscope, Phone, Mail, MapPin, ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-slate-50">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 sm:px-6 md:grid-cols-4 lg:px-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-blue-700 to-teal-600 text-white">
              <Stethoscope className="h-5 w-5" strokeWidth={2.4} />
            </div>
            <div className="text-lg font-extrabold tracking-tight text-slate-900">
              Doctor<span className="text-blue-700">+</span>
            </div>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-600">
            India's trusted doctor discovery &amp; appointment booking platform. Verified
            specialists, real-time clinic slots, and pay-at-clinic flexibility. Visit us at <span className="font-semibold text-slate-800">www.doctor-plus.in</span>.
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="badge bg-emerald-50 text-emerald-800">
              <ShieldCheck className="h-3.5 w-3.5" /> Verified Doctors
            </span>
            <span className="badge bg-blue-50 text-blue-800">INR ₹ Pricing</span>
            <span className="badge bg-teal-50 text-teal-800">All India</span>
          </div>
        </div>

        <div>
          <div className="text-sm font-semibold text-slate-900">Quick Links</div>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li><Link to="/doctors" className="hover:text-blue-700">Find Doctors</Link></li>
            <li><Link to="/specialties" className="hover:text-blue-700">Specialties</Link></li>
            <li><Link to="/register?role=doctor" className="hover:text-blue-700">For Doctors</Link></li>
            <li><Link to="/admin" className="hover:text-blue-700">Admin Portal</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold text-slate-900">Contact</div>
          <ul className="mt-4 space-y-2 text-sm text-slate-600">
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-blue-700" /> +91 1800-123-4567</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-blue-700" /> care@doctor-plus.in</li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-blue-700" /> Mumbai • Delhi • Bengaluru</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 py-5 text-xs text-slate-500 sm:px-6 lg:px-8">
          © {new Date().getFullYear()} Doctor+ (www.doctor-plus.in). All rights reserved. • Not a medical emergency service. For emergencies, dial 112.
        </div>
      </div>
    </footer>
  );
}
